import React from 'react'

export const DISHtml = ({value}) => <span dangerouslySetInnerHTML={{__html: value}} />
